import {z} from "zod";

const schema = z.object({
	fileId: z.string()
});

const model = schema.transform((values) => ({
	...values
}));

export const TaxAccountantStatusFile = {schema, model};
export type ITaxAccountantStatusFile = z.infer<typeof TaxAccountantStatusFile.model>;
export const DEFAULT_TAX_ACCOUNTANT_STATUS_FILE: ITaxAccountantStatusFile = {
	fileId: ""
};
